module.exports = __webpack_public_path__ + "static/media/Eli_M.7fdc392c.jpg";